import {ReactElement} from "react";
import VZThinkingStatusIcon from "./VZThinkingStatusIcon";
import css from "../styles/vz-thinking.module.scss";
import {VZThinkingStepState} from "../useVZThinkingRunner";


export interface VZThinkingStepProps {
    step: VZThinkingStepState;
    isLast: boolean;
}

export default function VZThinkingStep(props: VZThinkingStepProps): ReactElement {
    return (
        <div className={`${css.step} ${css[props.step.status]}`}>
            <div className={css.stepRail}>
                <VZThinkingStatusIcon status={props.step.status} />
                {!props.isLast && <div className={css.stepConnector} />}
            </div>

            <div className={css.stepContent}>
                <div className={css.stepTitle}>{props.step.title}</div>
                {props.step.subtitle !== "" &&
                    <div key={props.step.subtitle} className={css.stepSubtitle}>{props.step.subtitle}</div>
                }
            </div>
        </div>
    );
}
